import { getAuth } from 'firebase/auth';
import { collection, getDocs, query } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { db } from '../../firebase';

function Subscribe() {
    const [subscribes, setSubscribes] = useState([]);
    const [loading, setLoading] = useState(true);
    const auth = getAuth();
    const user = auth.currentUser;

    useEffect(() => {
        const fetchPayments = async () => {
          if (user) {
            const q = query(
              collection(db, "Subscribe")
            );
            const querySnapshot = await getDocs(q);
            const paymentsData = querySnapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));
            setSubscribes(paymentsData);
            setLoading(false);
          }
        };
    
        fetchPayments();
      }, [user]);

      const formatDate = (seconds) => {
        const date = new Date(seconds * 1000);
        const options = { day: "numeric", month: "long", year: "numeric" };
        const dateString = date.toLocaleDateString("fr-FR", options);
        const timeString = date.toLocaleTimeString("fr-FR", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${dateString} à ${timeString}`;
      };

  return (
    <div className='h-screen'>
      <Helmet>
        <title>Liste email s'abonnée</title>
      </Helmet>
      <h1 className="poppins-bold text-3xl md:text-5xl text-gray-900 text-center">
        E-mail s'abonnée
      </h1>
      <section class="relative mt-5">
        <div class="w-full max-w-7xl px-3 lg-6 space-y-2 mx-auto">
          <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
            <div className="overflow-x-auto">
              <table className="table">
                {/* head */}
                <thead className="text-gray-800 text-sm uppercase poppins-semibold">
                  <tr>
                    <th className="text-nowrap">#</th>
                    <th className="text-nowrap">E-mail</th>
                    <th className="text-nowrap">Date</th>
                  </tr>
                </thead>
                <tbody>
                {loading ? (
                  <tr className="bg-white border-b hover:bg-gray-50">
                    <td
                      colSpan={3}
                      className="text-center py-3 poppins-semibold uppercase"
                    >
                      <span className="loading loading-spinner loading-lg"></span>
                    </td>
                  </tr>
                ) : subscribes.length === 0 ? (
                  <tr className="bg-white border-b hover:bg-gray-50">
                    <td
                      colSpan={3}
                      className="text-center py-3 poppins-semibold uppercase"
                    >
                      Aucune e-mail s'abonnée enregistré
                    </td>
                  </tr>
                ) : (
                subscribes.map((subscribe, index) => (
                  <tr key={subscribe.id} className="text-gray-600">
                    <td className="text-nowrap">{index + 1}</td>
                    <td className="text-nowrap">{subscribe.email}</td>
                    <td>{formatDate(subscribe.dateCreated.seconds)}</td>
                  </tr>
                  ))
                )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Subscribe